import React from 'react';
import PropTypes from 'prop-types';

import {
  Title,
  Description,
  ActionsContainer,
  RoundedModal,
  ModalContentWrapper,
  HeaderContainer,
  ActionButton,
  CancelButton,
  StyledTextField,
  NoteInputContainer,
} from './styles';
import texts from './texts.json';

const ConfirmationModal = ({
  open,
  onClose,
  title,
  description,
  onConfirm,
  showAdditionalInput,
  onInputChange,
  inputLabel,
}) => (
  <RoundedModal
    open={open}
    onClose={onClose}
  >
    <ModalContentWrapper>
      <HeaderContainer>
        <Title>{title}</Title>
        {!!description && <Description>{description}</Description>}
      </HeaderContainer>
      {!!showAdditionalInput && (
        <NoteInputContainer>
          <StyledTextField
            label={inputLabel}
            variant="outlined"
            onChange={(e) => onInputChange(e.target.value)}
          />
        </NoteInputContainer>
      )}
      <ActionsContainer>
        <ActionButton onClick={onConfirm}>{texts.yes}</ActionButton>
        <CancelButton onClick={onClose}>{texts.no}</CancelButton>
      </ActionsContainer>
    </ModalContentWrapper>
  </RoundedModal>
);

ConfirmationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  showAdditionalInput: PropTypes.bool,
  onInputChange: PropTypes.func,
  inputLabel: PropTypes.string,
};
ConfirmationModal.defaultProps = {
  description: '',
  showAdditionalInput: false,
  onInputChange: () => {},
  inputLabel: texts.inputLabel,
};
export default ConfirmationModal;
